import { render, staticRenderFns } from "./CommonGrid.vue?vue&type=template&id=716736a5"
import script from "./CommonGrid.vue?vue&type=script&lang=js"
export * from "./CommonGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716736a5')) {
      api.createRecord('716736a5', component.options)
    } else {
      api.reload('716736a5', component.options)
    }
    module.hot.accept("./CommonGrid.vue?vue&type=template&id=716736a5", function () {
      api.rerender('716736a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/CommonGrid.vue"
export default component.exports